enum RobotEndpoints {
  GetRobotInfo = "/api/robot/getRobotInfo",
  ChangeRobotPercentMode = "/api/robot/changePercentMode",
}

export default RobotEndpoints;
